<template>
  <v-toolbar
    id="toolbar"
    dense
    floating
  >
    <v-btn icon @click.stop="toggleMainMenu" :title="$t('search.openMenu')">
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-autocomplete
      v-model="searchmodel"
      :items="items"
      dense
      clearable
      :search-input.sync="search"
      item-text="post_title"
      item-value="ID"
      :label="$t('search.searchMemories')"
      :placeholder="$t('search.search')"
      append-icon="mdi-magnify"
      single-line
      no-filter
      hide-details
      solo
      flat
    ></v-autocomplete>
    <v-btn icon @click.stop="$emit('toggle-filter')" :title="$t('search.filter')">
      <v-icon>mdi-filter</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>  
  export default {
    components: {
    },
    props: {
      items : {
        required: true
      }
    },
    computed: {
      search: {
        get () {
          return this.searchString
        },
        set (val) {
          this.$emit("update-search", val);
        }
      },
      searchmodel: {
        get () {
          return this.model
        },
        set (val) {
          this.$emit("update-search-model", val);
        }
      },
    },
    data () {
      return {
        model: null,
        searchString: null,
      }
    },
    created () {
    },
    watch: {
    },
    methods: {
      toggleMainMenu() {
        this.$store.state.nav = !this.$store.state.nav;
      },
    }
  }
</script>